const features = [
  { icon: 'ri-timer-flash-line', title: '15 Dakikada Yanınızda', desc: 'Çağrı aldıktan sonra ortalama 15 dakika içinde adresinizde oluyoruz.' },
  { icon: 'ri-24-hours-line', title: '7/24 Kesintisiz Hizmet', desc: 'Gece gündüz, hafta sonu ve resmi tatillerde de hizmetinizdeyiz.' },
  { icon: 'ri-shield-check-line', title: 'Lisanslı & Güvenilir', desc: 'Tüm çilingirlerimiz lisanslı, sigortalı ve deneyimli profesyonellerdir.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Şeffaf Fiyatlandırma', desc: 'Gizli ücret yok. İşlem öncesi net fiyat bilgisi veriyoruz.' },
  { icon: 'ri-tools-line', title: 'Hasarsız Açma', desc: 'Kapı ve kilit zarar görmeden, profesyonel ekipmanlarla açma garantisi.' },
  { icon: 'ri-map-pin-2-line', title: 'Geniş Hizmet Ağı', desc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'in tüm mahallelerinde.' },
];

export default function WhyUs() {
  return (
    <section className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-line"></i></span>
            Neden Alfa Çilingir?
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
            Farkımızı Hissedeceksiniz
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm md:text-base">
            Yılların deneyimi ve müşteri memnuniyeti odaklı yaklaşımımızla İstanbul'un en güvenilir çilingir firmasıyız.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl p-6 border border-stone-100 hover:border-orange-200 transition-all duration-300 group">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-50 text-orange-500 rounded-xl mb-4 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2">{f.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
